import React from 'react';
import { Interp, css, toList } from '../../lib/render.jsx';
import { Geluid, Kruis } from '../Iconen.jsx';

/**
 * Minigame: Krabbelworm!
 *
 * Het venster is een staande handheld: één behuizing in lila met het scherm erin
 * verzonken, daaronder de stand op één regel, en onderaan de zes toetsen op een
 * raster: het pijltjeskruis links, B en A rechts. Dezelfde indeling op elk
 * formaat, want staand past net zo goed op een telefoon als op een groot scherm.
 *
 * De ranglijst staat niet in het venster maar op het scherm, en alleen als je
 * beurt erop zit.
 *
 * Sturen doe je met de pijltjestoetsen, met WASD, met het kruis, of door over het
 * veld te vegen. De spatiebalk start en pauzeert, net als A en B.
 */
export default function Snake({ v }) {
  if (!v.showSnake) return null;
  return (
    <div className="gp-laag" onClick={v.closeSnake} style={{ "position": "fixed", "inset": "0", "background": "rgba(36,27,58,.7)", "display": "flex", "alignItems": "center", "justifyContent": "center", "zIndex": "97", "padding": "20px" }}>
      <div className="gp-venster" onClick={v.stopProp} style={css(v.snakePanelStyle)}>
        <div style={{ "display": "flex", "alignItems": "center", "gap": "12px", "flex": "0 0 auto" }}>
          <div style={css(v.snakeTitelStyle)}>
            <Interp v={v.snakeTitel} />
          </div>
          <button onClick={v.toggleSpelStil} title={v.spelStilTitel} aria-label={v.spelStilTitel} aria-pressed={v.spelStil ? 'true' : 'false'} style={css(v.sluitStyle)}>
            <Geluid maat={22} stil={v.spelStil} />
          </button>
          <button onClick={v.closeSnake} title="Sluiten" style={css(v.sluitStyle)}>
            <Kruis maat={22} />
          </button>
        </div>

        <div style={css(v.snakeConsoleStyle)}>
          <div style={css(v.snakeBoardStyle)} onTouchStart={v.snakeVeegStart} onTouchEnd={v.snakeVeegEind}>
            <canvas ref={v.snakeRef} width={v.snakeVeld} height={v.snakeVeld} role="img" aria-label="Het speelveld van Krabbelworm" style={css(v.snakeCanvasStyle)} />
            {v.showSnakeOver ? (
              <div style={css(v.snakeOverStyle)}>
                <div style={css(v.snakePlakStyle)}>
                  <div style={css(v.snakeOverKopStyle)}><Interp v={v.snakeOverKop} /></div>
                </div>
                {v.showSnakeEind ? (
                  <div style={css(v.snakePlakStyle)}>
                    <div style={css(v.snakeEindRegelStyle)}>
                      <span style={css(v.snakeEindLabelStyle)}><Interp v={v.snakeEindLabel} /></span>
                      <span style={css(v.snakeEindScoreStyle)}><Interp v={v.snakeEindScore} /></span>
                    </div>
                    <div style={css(v.snakeLijstStyle)}>
                      {toList(v.snakeTop).map((r, $index) => (
                        <React.Fragment key={$index}>
                          <div style={css(r?.rijStyle)}>
                            <span style={css(r?.plekStyle)}><Interp v={r?.plek} /></span>
                            <span style={css(r?.naamStyle)}><Interp v={r?.name} /></span>
                            <span style={css(r?.scoreStyle)}><Interp v={r?.score} /></span>
                          </div>
                        </React.Fragment>
                      ))}
                      {v.showSnakeLijstLeeg ? (
                        <div style={css(v.snakeLeegStyle)}><Interp v={v.snakeLijstLeeg} /></div>
                      ) : null}
                    </div>
                  </div>
                ) : null}
              </div>
            ) : null}
          </div>

          <div style={css(v.snakeBedieningStyle)}>
            {toList(v.snakeToetsen).map((t, $index) => (
              <React.Fragment key={$index}>
                <button onClick={t?.onClick} disabled={t?.uit} className={t?.klasse} title={t?.label} aria-label={t?.label} style={css(t?.style)}>
                  <Interp v={t?.teken} />
                </button>
              </React.Fragment>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
